import { $ } from './../helpers/query';
import photosGray from './home/photos-gray';
import types from './home/types';
import plans from './home/plans';
import building from './home/building';
import maps from './home/maps';
import gallery from './home/gallery';
import downloads from './home/downloads';
import tablefilter from './home/tablefilter';
import "@lottiefiles/lottie-player";

export default () => {

  photosGray();
  types();
  plans();
  building();
  maps();
  gallery();
  downloads();
  tablefilter();
}
